import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export function DownloadIcon(props: SvgIconProps) {
  const fill = props.fill ?? props.color ?? '#4760F6';
  return (
    <SvgIcon
      {...props}
      viewBox='0 0 16 16'
    >
      <g id='Layer 2'>
        <g id='download'>
          <path
            id='Vector'
            d='M12.6665 12H3.33317C2.96498 12 2.6665 12.2985 2.6665 12.6667C2.6665 13.0349 2.96498 13.3333 3.33317 13.3333H12.6665C13.0347 13.3333 13.3332 13.0349 13.3332 12.6667C13.3332 12.2985 13.0347 12 12.6665 12Z'
            fill={fill}
          />
          <path
            id='Vector_2'
            d='M2.6665 11.3335V12.6668C2.6665 13.035 2.96498 13.3335 3.33317 13.3335C3.70136 13.3335 3.99984 13.035 3.99984 12.6668V11.3335C3.99984 10.9653 3.70136 10.6668 3.33317 10.6668C2.96498 10.6668 2.6665 10.9653 2.6665 11.3335Z'
            fill={fill}
          />
          <path
            id='Vector_3'
            d='M12 11.3335V12.6668C12 13.035 12.2985 13.3335 12.6667 13.3335C13.0349 13.3335 13.3333 13.035 13.3333 12.6668V11.3335C13.3333 10.9653 13.0349 10.6668 12.6667 10.6668C12.2985 10.6668 12 10.9653 12 11.3335Z'
            fill={fill}
          />
          <path
            id='Vector_4'
            d='M7.9998 9.99984C7.86159 10.0009 7.72647 9.95895 7.61314 9.87984L4.94647 7.99984C4.80275 7.89788 4.70523 7.74317 4.67525 7.56952C4.64527 7.39588 4.68526 7.21742 4.78647 7.07317C4.837 7.00107 4.9013 6.93969 4.97567 6.89258C5.05005 6.84546 5.13302 6.81355 5.21979 6.79867C5.30657 6.78379 5.39543 6.78625 5.48125 6.80591C5.56707 6.82556 5.64815 6.86202 5.7198 6.91317L7.9998 8.50651L10.2665 6.79984C10.4079 6.69375 10.5857 6.6482 10.7608 6.67321C10.9358 6.69821 11.0937 6.79172 11.1998 6.93317C11.3059 7.07462 11.3514 7.25242 11.3264 7.42745C11.3014 7.60249 11.2079 7.76042 11.0665 7.86651L8.3998 9.86651C8.28441 9.95305 8.14405 9.99984 7.9998 9.99984Z'
            fill={fill}
          />
          <path
            id='Vector_5'
            d='M8.00016 8.66667C7.82335 8.66667 7.65378 8.59643 7.52876 8.4714C7.40373 8.34638 7.3335 8.17681 7.3335 8V2.66667C7.3335 2.48986 7.40373 2.32029 7.52876 2.19526C7.65378 2.07024 7.82335 2 8.00016 2C8.17697 2 8.34654 2.07024 8.47157 2.19526C8.59659 2.32029 8.66683 2.48986 8.66683 2.66667V8C8.66683 8.17681 8.59659 8.34638 8.47157 8.4714C8.34654 8.59643 8.17697 8.66667 8.00016 8.66667Z'
            fill={fill}
          />
        </g>
      </g>
    </SvgIcon>
  );
}
